import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'
import { useIsMobile } from 'utils/useIsMobile'

const CurrentPriceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div:first-child {
    @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
      display: flex;
      align-items: baseline;
    }
  }
`

// const FullRange = styled.div`
//   display: flex;
//   width: 120px;
//   height: 40px;
//   justify-content: center;
//   align-items: center;
//   gap: 8px;
//   border-radius: 100px;
//   border: 1px solid #043754;
//   background-color: transparent;
//   cursor: pointer;
// `

interface Props {
  tokenXSymbol: string
  tokenYSymbol: string
  currentPrice?: string
  // isNewPosition?: boolean
}

export const CurrentPrice = ({ currentPrice, tokenXSymbol, tokenYSymbol }: Props) => {
  const isMobile = useIsMobile()

  if (!currentPrice) {
    return null
  }

  return (
    <div style={{ marginBottom: 12 }}>
      <Typography variant="description" color="secondary" fontWeight="medium">
        Current Price
      </Typography>
      <CurrentPriceContainer>
        <div>
          <Typography variant="label1" fontWeight="bold">
            {currentPrice}
          </Typography>
          <Typography variant="caption" color="secondary" style={isMobile ? {} : { marginLeft: 4 }}>
            {tokenYSymbol} per {tokenXSymbol}
          </Typography>
        </div>
        {/* {isNewPosition && (
          <FullRange>
            <Typography variant="description" fontWeight="medium">
              Full Range
            </Typography>
          </FullRange>
        )} */}
      </CurrentPriceContainer>
    </div>
  )
}
